import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

const MONEY_SERIES = [
  { key: 'revenue', label: 'Revenue' },
  { key: 'costOfRevenue', label: 'Cost of Revenue' },
  { key: 'grossProfit', label: 'Gross Profit' },
  { key: 'netIncome', label: 'Net Income' },
  { key: 'ebitda', label: 'EBITDA' }
];

const YEAR_SERIES_COLORS = [
  '#0f766e',
  '#2563eb',
  '#7c3aed',
  '#ea580c',
  '#dc2626',
  '#0891b2',
  '#65a30d',
  '#c026d3'
];

const formatBillions = (value) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return value;
  }

  return `$${(value / 1_000_000_000).toFixed(1)}B`;
};

const pivotChartData = (chartData) => {
  const years = chartData.map((row) => row.fiscalYear);

  return {
    years,
    rows: MONEY_SERIES.map(({ key, label }) => {
      const row = { metric: label };

      chartData.forEach((yearRow) => {
        row[yearRow.fiscalYear] = yearRow[key];
      });

      return row;
    })
  };
};

export default function IncomeStatementChart({ chartData = [], selectedStock }) {
  if (!chartData.length) {
    return <p>No income statement data loaded for {selectedStock}.</p>;
  }

  const { years, rows } = pivotChartData(chartData);

  return (
    <div className="chart-wrapper">
      <h3>{selectedStock} Income Statement</h3>
      <ResponsiveContainer width="100%" height={420}>
        <BarChart data={rows} margin={{ top: 16, right: 16, left: 16, bottom: 16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="metric" />
          <YAxis tickFormatter={formatBillions} width={90} />
          <Tooltip formatter={(value, name) => [formatBillions(value), name]} />
          <Legend />
          {years.map((year, index) => (
            <Bar
              key={year}
              dataKey={year}
              name={year}
              fill={YEAR_SERIES_COLORS[index % YEAR_SERIES_COLORS.length]}
              radius={[4, 4, 0, 0]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
